/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Infektionsschutzid2Inputs */



/**

* @param {_Field_Infektionsschutzid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_infektionsschutzid2 = /** @type {((inputs?: _Field_Infektionsschutzid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Infektionsschutzid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Infektionsschutzbelehrung")
});
export { _field_infektionsschutzid2 as "_field_infektionsschutzID" }